export default __webpack_public_path__ + "static/media/redMinus.6aeb1c37.svg";